export default __webpack_public_path__ + "static/media/8Loop.eb0d0342.mp4";